import React, { Component, useEffect } from 'react';
import '../css/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from '../Component/form';
import AOS from 'aos';
import 'aos/dist/aos.css'
import {Switch, Route, Redirect} from 'react-router-dom';

function Home(){

    useEffect(()=>{
        AOS.init({duration:3000})
        },[]);
    return(
        <div data-AOS="fade-up" className="row ml-2">
        <div className="container">
            <h6>Hi, my name is</h6>
            <h1 className="name">Karan Patel.</h1>
            <h2 className="des">I build amazing things for the Computer and web.</h2>
            <p className="para">I'm a software engineer based in Bangalore, India specializing in building (and occasionally designing) exceptional websites, applications, and everything in between.</p>
            <a target="blank"href="con"><button className="getint" type="button">Get in Touch</button></a>
            
        </div>
        </div>
    )

}

export default Home;